import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import NewsCard from "@/components/cards/NewsCard";
import { newsList } from "@/mocks/news";

export default function NewsHighlights() {
  const items = newsList.slice(0, 3);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="NEWS"
          title="新闻快讯"
          description="第一时间掌握「蜜桃成熟时3D」的影片动态、幕后访谈与影展资讯，与影片的每一步进展保持同步。"
          action={
            <Link
              to="/news"
              className="flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              查看全部资讯
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}